/* ==========================================================================
   MAIN COLLECTION — Standalone JS (no OLD dependencies)
   Handles: Infinite scroll / Load more, Filter/Sort AJAX, Toggle details
   ========================================================================== */
(function () {
  'use strict';

  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  var sectionId = grid.dataset.sectionId;

  /* ========================================================================
     A. INFINITE SCROLL / LOAD MORE
     ======================================================================== */

  var loadMoreContainer = null;
  var loadMoreObserver = null;
  var loading = false;

  function initLoadMore() {
    if (loadMoreObserver) {
      loadMoreObserver.disconnect();
      loadMoreObserver = null;
    }

    loadMoreContainer = document.querySelector('[data-load-more]');
    if (!loadMoreContainer) return;

    var mode = loadMoreContainer.dataset.mode;
    var btn = loadMoreContainer.querySelector('[data-load-more-btn]');
    var spinner = loadMoreContainer.querySelector('[data-loading]');

    if (mode === 'auto' || mode === 'both') {
      loadMoreObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          fetchNextPage();
        }
      }, { rootMargin: '400px' });
      loadMoreObserver.observe(loadMoreContainer);
    }

    if (btn) {
      btn.addEventListener('click', function () {
        fetchNextPage();
      });
    }

    function fetchNextPage() {
      var nextUrl = loadMoreContainer.dataset.nextUrl;
      if (!nextUrl || loading) return;

      loading = true;
      if (btn) btn.disabled = true;
      if (spinner) spinner.hidden = false;

      var fetchUrl = nextUrl + (nextUrl.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');

          if (newGrid) {
            var children = Array.from(newGrid.children);
            children.forEach(function (child) {
              grid.appendChild(child);
            });
          }

          var newLoadMore = doc.querySelector('[data-load-more]');
          if (newLoadMore && newLoadMore.dataset.nextUrl) {
            loadMoreContainer.dataset.nextUrl = newLoadMore.dataset.nextUrl;
          } else {
            loadMoreContainer.dataset.nextUrl = '';
            loadMoreContainer.hidden = true;
            if (loadMoreObserver) loadMoreObserver.disconnect();
          }

          var toggle = document.querySelector('[data-toggle-details]');
          if (toggle && toggle.checked) {
            applyDetailsState(true);
          }
          applyFieldVisibility(getSavedFields());

          loading = false;
          if (btn) btn.disabled = false;
          if (spinner) spinner.hidden = true;
        })
        .catch(function () {
          loading = false;
          if (btn) btn.disabled = false;
          if (spinner) spinner.hidden = true;
        });
    }
  }

  initLoadMore();

  /* ========================================================================
     B. FILTER / SORT AJAX
     ======================================================================== */

  // Handle apply button click in filter overlay
  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-overlay-apply]');
    if (!applyBtn) return;

    e.preventDefault();
    var overlayId = applyBtn.dataset.overlayApply;
    var dialog = document.getElementById(overlayId);
    if (!dialog) return;

    var form = dialog.querySelector('form');
    if (!form) return;

    applyFacets(form, dialog);
  });

  // Handle sort option changes (radio buttons in sort overlay)
  document.addEventListener('change', function (e) {
    var sortDrawer = document.getElementById('collection-sort-drawer');
    if (!sortDrawer) return;
    if (!sortDrawer.contains(e.target)) return;
    if (e.target.name !== 'sort_by') return;

    var form = sortDrawer.querySelector('form');
    if (!form) return;

    applyFacets(form, sortDrawer);
  });

  // Handle filter link clicks (for removing active filters)
  document.addEventListener('click', function (e) {
    var filterLink = e.target.closest('.active-facets a');
    if (!filterLink) return;

    e.preventDefault();
    var url = filterLink.href;
    if (!url) return;

    fetchAndReplace(url);
  });

  // Handle clear filters button in overlay footer
  document.addEventListener('click', function (e) {
    var clearLink = e.target.closest('[data-facet-clear]');
    if (!clearLink) return;

    e.preventDefault();
    var dialog = clearLink.closest('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();

    fetchAndReplace(clearLink.href);
  });

  function applyFacets(form, dialog) {
    var formData = new FormData(form);
    var params = new URLSearchParams();

    // FormData to URLSearchParams (skip empty/disabled)
    for (var pair of formData.entries()) {
      if (pair[1] !== '' && pair[0] !== 'section_id') {
        params.append(pair[0], pair[1]);
      }
    }

    var url = form.action + '?' + params.toString();

    // Close overlay
    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }

    fetchAndReplace(url);
  }

  function fetchAndReplace(url) {
    // Update browser URL
    history.pushState(null, '', url);

    var fetchUrl = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;

    // Show loading state
    grid.style.opacity = '0.5';
    grid.style.pointerEvents = 'none';

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Replace grid
        var newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
        }

        // Replace load-more container
        var newLoadMore = doc.querySelector('[data-load-more]');
        var currentLoadMore = document.querySelector('[data-load-more]');
        if (currentLoadMore && newLoadMore) {
          currentLoadMore.replaceWith(newLoadMore);
        } else if (currentLoadMore && !newLoadMore) {
          currentLoadMore.hidden = true;
        } else if (!currentLoadMore && newLoadMore && grid.parentNode) {
          grid.parentNode.insertBefore(newLoadMore, grid.nextSibling);
        }
        initLoadMore();

        // Replace pagination
        var currentPagination = document.querySelector('.sx-pagination');
        var newPagination = doc.querySelector('.sx-pagination');
        if (currentPagination && newPagination) {
          currentPagination.replaceWith(newPagination);
        }

        // Update sort label in toolbar
        var newToolbar = doc.querySelector('.main-collection__toolbar');
        var currentSortBtn = document.querySelector('[data-overlay-open="collection-sort-drawer"]');
        var newSortBtn = newToolbar ? newToolbar.querySelector('[data-overlay-open="collection-sort-drawer"]') : null;
        if (currentSortBtn && newSortBtn) {
          currentSortBtn.innerHTML = newSortBtn.innerHTML;
        }

        // Update filter button (count badge)
        var currentFilterBtn = document.querySelector('[data-overlay-open="collection-filter-drawer"]');
        var newFilterBtn = newToolbar ? newToolbar.querySelector('[data-overlay-open="collection-filter-drawer"]') : null;
        if (currentFilterBtn && newFilterBtn) {
          currentFilterBtn.innerHTML = newFilterBtn.innerHTML;
        }

        // Update filter overlay content
        var newFilterDrawer = doc.querySelector('#collection-filter-drawer');
        var currentFilterDrawer = document.getElementById('collection-filter-drawer');
        if (currentFilterDrawer && newFilterDrawer) {
          var currentBody = currentFilterDrawer.querySelector('.overlay-drawer__body');
          var newBody = newFilterDrawer.querySelector('.overlay-drawer__body');
          if (currentBody && newBody) {
            currentBody.innerHTML = newBody.innerHTML;
          }

          // Update filter overlay footer (clear button visibility)
          var currentFooter = currentFilterDrawer.querySelector('.overlay-drawer__footer');
          var newFooter = newFilterDrawer.querySelector('.overlay-drawer__footer');
          if (currentFooter && newFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          }

          if (window.initAccordions) window.initAccordions(currentFilterDrawer);
        }

        // Update field filters bar
        var newFieldFilters = doc.querySelector('[data-field-filters]');
        var currentFieldFilters = document.querySelector('[data-field-filters]');
        if (currentFieldFilters && newFieldFilters) {
          currentFieldFilters.innerHTML = newFieldFilters.innerHTML;
          fieldFilters = currentFieldFilters;
          initFieldFilters();
          if (window.initAccordions) window.initAccordions(currentFieldFilters);
          if (toggle && toggle.checked) fieldFilters.hidden = false;
        }

        // Apply details state
        if (toggle && toggle.checked) {
          applyDetailsState(true);
        }
        applyFieldVisibility(getSavedFields());

        // Restore grid
        grid.style.opacity = '';
        grid.style.pointerEvents = '';

        // Scroll to top of section
        var section = document.querySelector('.shopify-section--main-collection');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () {
        grid.style.opacity = '';
        grid.style.pointerEvents = '';
      });
  }

  // Handle browser back/forward
  window.addEventListener('popstate', function () {
    fetchAndReplace(window.location.href);
  });

  /* ========================================================================
     C. TOGGLE TECHNICAL DETAILS
     ======================================================================== */

  var toggle = document.querySelector('[data-toggle-details]');
  var fieldFilters = document.querySelector('[data-field-filters]');

  if (toggle) {
    // Initial state already set via Liquid class on grid
    toggle.addEventListener('change', function () {
      applyDetailsState(toggle.checked);
      if (fieldFilters) fieldFilters.hidden = !toggle.checked;
    });
    // Au chargement, si déjà coché → afficher filtres
    if (toggle.checked && fieldFilters) fieldFilters.hidden = false;
  }

  // Per-card quick action toggle
  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="toggle-details"]');
    if (!btn) return;

    var card = btn.closest('.product-card-showcase');
    if (!card) return;

    var isActive = card.classList.toggle('details-active');
    btn.setAttribute('aria-expanded', String(isActive));
  });

  function applyDetailsState(show) {
    grid.classList.toggle('main-collection__grid--show-details', show);

    grid.querySelectorAll('.product-card-showcase').forEach(function (card) {
      card.classList.toggle('details-active', show);
    });

    if (show) applyFieldVisibility(getSavedFields());
  }

  /* ========================================================================
     D. FIELD VISIBILITY & LOCALSTORAGE
     ======================================================================== */

  var collectionHandle = grid.dataset.collectionHandle || '';
  var storageKey = 'tech_fields_' + collectionHandle;
  var allFieldKeys = [];

  try { allFieldKeys = JSON.parse(grid.dataset.techFields || '[]'); } catch (e) {}

  function getSavedFields() {
    try {
      var saved = localStorage.getItem(storageKey);
      if (saved !== null) return JSON.parse(saved);
    } catch (e) {}
    return allFieldKeys.slice(); // défaut: tout coché
  }

  function saveFieldState(checkedKeys) {
    try { localStorage.setItem(storageKey, JSON.stringify(checkedKeys)); } catch (e) {}
  }

  function applyFieldVisibility(checkedKeys) {
    grid.querySelectorAll('[data-field-key]').forEach(function (item) {
      item.hidden = checkedKeys.indexOf(item.dataset.fieldKey) === -1;
    });
  }

  function initFieldFilters() {
    if (!fieldFilters) return;
    var savedKeys = getSavedFields();
    var checkboxes = fieldFilters.querySelectorAll('[data-field-toggle]');
    checkboxes.forEach(function (cb) {
      cb.checked = savedKeys.indexOf(cb.dataset.fieldToggle) !== -1;
      cb.addEventListener('change', function () {
        var currentKeys = [];
        checkboxes.forEach(function (c) { if (c.checked) currentKeys.push(c.dataset.fieldToggle); });
        saveFieldState(currentKeys);
        applyFieldVisibility(currentKeys);
      });
    });
    applyFieldVisibility(savedKeys);
  }

  initFieldFilters();

  /* ========================================================================
     E. COLLECTION PROMO — Marquee scroll on hover (when text is truncated)
     ======================================================================== */

  function initPromoMarquee(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('.collection-promo__cta .button');
    buttons.forEach(function (btn) {
      if (btn.dataset.marqueeInit === '1') return;
      btn.dataset.marqueeInit = '1';

      btn.addEventListener('mouseenter', function () {
        var overflow = btn.scrollWidth - btn.clientWidth;
        if (overflow <= 0) return;
        // ~60px per second, min 1s
        var duration = Math.max(1, overflow / 60);
        btn.style.setProperty('--marquee-distance', '-' + overflow + 'px');
        btn.style.setProperty('--marquee-duration', duration + 's');
        btn.classList.add('is-scrolling');
      });

      btn.addEventListener('mouseleave', function () {
        btn.classList.remove('is-scrolling');
      });
    });
  }

  initPromoMarquee();
  // Re-init when grid gets new nodes (filter/sort replace)
  var promoObserver = new MutationObserver(function () { initPromoMarquee(grid); });
  promoObserver.observe(grid, { childList: true, subtree: true });
})();
